import $ from "jquery";
import * as d3 from "d3";

let urlRoot ='';

function displaySourceMetadata(file_exists, metadata_file_path, nodes) {
	let metadata_html = "<p>Results are available to download below.</p>";
	if (file_exists) {
		metadata_html += "<p><b>When using this data, please cite any publications and contact the data " +
			"contributor(s) listed in the following file</b> (under ManuscriptURL__, ContactName__, and " +
			"ContactEmail__), where you can also view other information about the source files used to build " +
			"the data in the query output: <a href='" + metadata_file_path + "' class='btn btn-primary'>" +
			"<b>Metadata_" + nodes + ".csv</b></a></p>";
	} else {
		metadata_html += "<p><b>Please <a href='/contact_us' target='_blank'><u>contact us</u></a> and " +
			"cite the IsoGenieDB when using this data.</b></p>";
	}
	$('.metadata-download').html(metadata_html);
}

function displayTablePrompt(filesize, nodes) {
	let link_html = `<p>Query output (file size: ${filesize} ): <a href='${urlRoot}/downloads/${nodes}.csv' class='btn btn-primary'><b>${nodes}.csv</b></a></p>`;

	$('.csv-download').html(link_html);

}


export function querySubmit() {

	let label = $('#nodes').val();
	let nodes = label[0].replace(/\s/g, '');  // remove spaces from labels that have them to get filenames without spaces

	let metadata_file_path = `${urlRoot}/downloads/Metadata_${nodes}.csv`;
	let file_exists = false;
	$.ajax({
		'type': 'HEAD',
		'url': metadata_file_path,
		'success': function () {
			file_exists = true;
			displaySourceMetadata(file_exists, metadata_file_path, nodes);
		},
		'error': function (xhr, status, error) {
			console.log(error);
			displaySourceMetadata(file_exists, metadata_file_path, nodes);
		},
	});


	// Get file size (of CSV) to warn about displaying table for large query results
	let filesize = 'not yet found';
	let csvrequest = $.ajax({
		'type': 'HEAD',
		'url': `${urlRoot}/downloads/${nodes}.csv`,
		'success': function () {
			filesize = csvrequest.getResponseHeader('Content-Length') / 1000000 + ' MB';
			displayTablePrompt(filesize, nodes);
			//alert("Size is " + filesize);

		},
		'error': function (xhr) {
			filesize = 'unknown';
			let err = xhr.responseText;
			alert(err);
			displayTablePrompt(filesize, nodes);
		},
	});


}

export function init(importedUrlRoot){

	urlRoot = importedUrlRoot;
// Dynamically show the actual labels along with the descriptions
	let allLabels = $('#nodes option');


	d3.json(`${urlRoot}/longLabelDescriptions.json`).then(function (json) {
		console.log('json');
		let longLabelDescriptions = json;
		console.log(longLabelDescriptions);

		$.each(allLabels, function (i, j) {

			let label = $(j).prop('value');
			let labeltext = $(j).text();

			// Color code by label categories
			$(j).addClass(longLabelDescriptions[label]["class"])

			// Use the "title" property to make long descriptions that pop up on mouseover.
			$(j).prop('title', longLabelDescriptions[label]["description"]);

			// letiable number of spaces
			// (this only works correctly with monospace font, and can't use child elements inside an <option> to mix
			// different fonts, so the entire selection box must use monospace)

			let formatted_label = label;
			// The longest label (currently) is Biogeochemistry, which is 15 characters.
			// Set the # of added spaces so that the total length is 18.
			let nspaces = 18 - label.length;
			if (nspaces < 2) {
				nspaces = 2;  // make sure there's always at least 2 spaces
			}
			for (i = 0; i < nspaces; i++) {
				formatted_label += "&nbsp;";
			}

			let final_labeltext = formatted_label + labeltext;

			$(j).html(final_labeltext);
		});
	});


	$('#selectcat').change(function () {
		let selectionEl = $('#selectprod option');
		let allOptions = selectionEl;
		selectionEl.remove();
		let classN = $('#selectcat option:selected').prop('class');
		let opts = allOptions.filter('.' + classN);
		$.each(opts, function (i, j) {
			$(j).appendTo('#selectprod');
		});
	});

	document.querySelector('#cached-form').addEventListener('submit', querySubmit);
}
